<div class="harvest-tax-loss-rebalance-settings">
  <div class="flex-row">
    <div class="flex-column flex-column-header">
      <strong>Tax Loss Harvest the same way as:
        <span class="tooltipIconLeft infoIcon" calltoaction
          [calltoactionTemplate]="harvestTaxLossSameWayInfoToolTipIcon">
        </span>
      </strong>
    </div>
    <div class="flex-column">
      <irb-dropdown-filter #harvestedSecuritiesSameWayAsDropdown
        id="irbSelectedRebalanceTypeDropdown"
        [value]="htlTargets.items"
        placeholder="Select Tax Loss Harvest To Clone"
        [disabled]="isReadOnly"
        (search)="setChainTypeOptions($event)"
        (selection)="onHtlChange($event)"
      ></irb-dropdown-filter>
    </div>
    <div class="flex-column">
      <button class="btn-medium-secondary btn-spacer" [disabled]="isReadOnlyClear" (click)="onClearTaxLossToClone()">Clear</button>
    </div>
  </div>
  <div class="flex-row">
    <div class="flex-column flex-column-header">
      <strong>Loss detection level </strong>
      <span class="tooltipIconLeft infoIcon" calltoaction
        [calltoactionTemplate]="harvestSecuritySettingsLDLInfoToolTipIcon">
      </span>
    </div>
    <div class="flex-column">
      <div class="checkboxes-horizontal-align">
        <div class="flex-radio-item">
          <p-radioButton name="harvest-lot-level" inputId="htlitem1"
            [value]="false"
            [disabled]="isReadOnly"
            [(ngModel)]="data.harvestTaxLossDto.isLotLevel"
          (ngModelChange)="onPositionLevelChange()"></p-radioButton>
            <label for="htlitem1" >Position level</label>
        </div>
        <div class="flex-radio-item">
          <p-radioButton name="harvest-lot-level" inputId="htlitem2"
            [value]="true"
            [disabled]="isReadOnly"
            [(ngModel)]="data.harvestTaxLossDto.isLotLevel"
          (ngModelChange)="onPositionLevelChange()"></p-radioButton>
            <label for="htlitem2" >Lot level</label>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-row">
    <div class="flex-column flex-column-header"><strong>Securities to be harvested</strong></div>
    <div class="flex-column fixed-width-column">
      <div class="flex-securities-search-container">
        <div class="search-add-container">
          <div class="search-symbol-header">Search by symbol</div>
          <div>
            <irb-dropdown-search-multiple #harvestedSecuritiesDropdown
                                          style="margin-left: 10px;
                      vertical-align: bottom;
                      margin-bottom: -2px;
                      display: inline-block;"
              size="30"
              [addNewItem]="addNewSecurityItem"
              (openNewItemFlow)="openNewItemSecurityFlow($event, false)"
              [(values)]="securitiesTargetsSelected"
              (search)="filterSecurities($event)"
              [enableHiddenSearchResults]="true"
              (selection)="captureAddSecurity($event)">
            </irb-dropdown-search-multiple>
          </div>
          <div>
            <button class="btn-medium-secondary securities-to-be-harvested btn-spacer" [disabled]="isReadOnly || !disableAddHarvestSec()" (click)="addSecurity()">
              Add
            </button>
          </div>
        </div>
        <div class="search-add-container">
          <div class="search-symbol-header"> Search by attributes</div>
          <div>

            <button id="advancedFilterButton" (click)="showAddMultipleSecuritiesDialog()" [disabled]="isReadOnly"
              class="btn-medium-secondary replace-securiries-btn-add-multi">Advanced Filter
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-row zero-bottom-margin">
    <div class="flex-column flex-column-header">
      <strong>Harvest Securities Settings
        <span class="tooltipIconLeft infoIcon" calltoaction
          [calltoactionTemplate]="harvestSecuritySettingsInfoToolTipIcon">
        </span>
      </strong>
    </div>
    <div class="flex-column">
      <div class="flex-harvest-settings-container">
        <div class="harvest-settings-row-container">
          Specify values to apply to all securities listed below (optional)
        </div>
        <div class="harvest-settings-row-container">
          <div class="harvest-settings-column-container">
            <div class="harvest-settings-header">%</div>
            <div>
              <irb-number-text-box [(value)]="percentAmount" [isPercentage]="true" places="2" min="0"
                max="100" invalidRangeMessage="Please enter a value between 0..100" [disabled]="isReadOnly" width="140px"  (change)="onPercentChange()">
              </irb-number-text-box>
            </div>
            <div>
              <button class="btn-medium-secondary btn-spacer" [disabled]="isReadOnly || rowCount === 0" (click)="onPercentAmountApply()">Apply</button>
              @if (toolTipShowPercent) {
                <div class="tooltip shadow right error" style="width:250px;margin-left: 10px;margin-top: -5px;"
                  >
                  <div class="arrow shadow"></div>
                  <div class="tooltip-body-title" [innerHTML]="tooltipMessagePercent"
                  style="max-width: 300px; word-wrap: break-word;"></div>
                </div>
              }
            </div>
          </div>
          <div class="harvest-settings-column-container">
            <div class="harvest-settings-header harvest-settings-header-margin-left">$&nbsp;amt</div>
            <div><irb-number-text-box [(value)]="dollarAmount" [isCurrency]="true" [disabled]="isReadOnly" [isRequired]="true"
              places="2" width="140px" min="0" (change)="onDollarChange()">
            </irb-number-text-box></div>
            <div>

              <button class="btn-medium-secondary btn-spacer" [disabled]="isReadOnly || rowCount === 0" (click)="onDollarAmountApply()">Apply</button>
              @if (toolTipShowDollar) {
                <div class="tooltip shadow right error" style="width:250px;margin-left: 10px;margin-top: -5px;"
                  >
                  <div class="arrow shadow"></div>
                  <div class="tooltip-body-title" [innerHTML]="tooltipMessageDollar"
                  style="max-width: 300px; word-wrap: break-word;"></div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex-row zero-bottom-margin">
    <div class="flex-column flex-column-header"></div>
    <div class="flex-column"><strong>{{rowCount}} securities to harvest</strong></div>
  </div>
  <div class="flex-row">
    <div class="flex-column flex-column-header"></div>
    <div class="flex-column fixed-width-column">
      <div style="width: 730px;">
        @if (!isUiTest) {
          <irb-inventory-grid
            [style.width]="'100%'"
            [style.maxWidth]="'730px'"
            [style.height]="'240px'"
            [gridHeight]="'240px'"
            [showSideBar]="false"
            [gridOptions]="gridOptions"
            [frameworkComponents]="frameworkComponents"
          (gridReady)="onGridReady($event)"></irb-inventory-grid>
        }
      </div>
    </div>
  </div>
</div>
<ng-template #harvestTaxLossSameWayInfoToolTipIcon>
  You can select from one of your previous 5 tax harvests to have iRebal copy the list of harvest securities and their settings into this tax harvest, so you don't have to enter these settings again. You can edit the settings after copying them from a previous tax harvest.
</ng-template>
<ng-template #harvestSecuritySettingsInfoToolTipIcon>
  After selecting securities to harvest, you can use these to quickly apply the same min loss % or amount thresholds, and/or replacement securities for all harvest securities, so you don't have to enter the same settings for each security. You can edit the settings for any individual security after applying these same settings to all.
</ng-template>
<ng-template #harvestSecuritySettingsLDLInfoToolTipIcon>
  Select Position level if you only wish to harvest when an entire holding in an account can be sold while meeting your thresholds. <br>
  <br>
    Select Lot level if you are willing to sell partial holdings as part of tax loss harvesting.
  </ng-template>
